import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Globals } from '../../globals'

@Component({
  selector: 'iep-ap',
  templateUrl: './IEP-AP.component.html',
})
export class IEPAPComponent {

  _myGlobals: Globals;

  constructor(private globals: Globals) {
    this._myGlobals = globals;
  }

}
